export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10186.dc8c1478.jpg";